import { useCallback } from 'react';

import type { ApplicationType } from '@xing-com/crate-jobs-helpers';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

type UseTrackApplyIntentionArgs = {
  applicationType: ApplicationType;
  jobId: string;
};
type TrackApplyIntentionCallback = () => void;

const applicationTypeNwtContext: Record<ApplicationType, string> = {
  EmailApplication: 'email_apply',
  JobXingApplication: 'instant_apply',
  MessageApplication: 'private_message_apply',
  UrlApplication: 'url_apply',
  EasyApplication: '',
  JobXingCustomApplication: 'custom_questions_apply',
};

export const useTrackApplyIntention = ({
  applicationType,
  jobId,
}: UseTrackApplyIntentionArgs): TrackApplyIntentionCallback => {
  const trackNwt = useJobsNwtTracking();

  return useCallback(() => {
    if (applicationTypeNwtContext[applicationType]) {
      trackNwt({
        eventSchema: 'basic',
        event: 'intended',
        intention: 'apply',
        page: 'jobs/detail',
        itemUrn: `surn:x-xing:jobs:posting:${jobId}`,
        element: 'apply_button',
        context: applicationTypeNwtContext[applicationType],
      });
    }
  }, [applicationType, jobId, trackNwt]);
};
